import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DesignRirekisho002PreviewDocPage2',
  props: {
    formatData: null,
    idPrefix: null,
    docPaperPage2Style: null,
    goCardTo: null,
    highLightClass: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})